import React, { Component, PropTypes } from 'react';
import StoreVideoPlayer from '../StoreVideoPlayer';

class StoreVideoModule extends Component {
  static propTypes = {
    embedUrl: PropTypes.string,
    caption: PropTypes.string
  };

  render() {
    const { embedUrl, caption } = this.props;
    return <StoreVideoPlayer src={embedUrl} caption={caption} />;
  }
}

export default StoreVideoModule;



// WEBPACK FOOTER //
// ./src/js/components/Store/Modules/StoreVideoModule.js